import compose from "recompose/compose";
import graphqlWithPreload from "web/core/apollo/graphqlWithPreload";
import withProductsByOptions from "theme/modules/ProductView/withProductsByOptions";
import withSelectedOptions from "theme/modules/ProductView/withSelectedOptions";
import withSelectedCustomOptions from "theme/modules/ProductView/withSelectedCustomOptions";
import withSelectedBundleOptions from "theme/modules/ProductView/withSelectedBundleOptions";
import withSelectedGroupedItems from "theme/modules/ProductView/withSelectedGroupedItems";
import withProductAddedPopIn from "theme/modules/ProductAddedPopIn/withProductAddedPopIn";
import Loadable from "theme/components/helpers/Loadable";
import LoadingRoute from "theme/modules/Router/LoadingRoute";

const EnhanceAddToCartModal = ({ AddToCartModalQuery, withLoader = true }) =>
  compose(
    graphqlWithPreload(AddToCartModalQuery, {
      options: ({ product }) => ({
        variables: {
          sku: product.sku,
        },
      }),
      props: ({ data }) => ({
        product: data.product,
        loading:
          data.loading || (!data.error && typeof data.product === "undefined"),
        error: data.error,
      }),
    }),
    Loadable((props) => !props.loading, withLoader ? LoadingRoute : () => null),
    withProductAddedPopIn(),
    withProductsByOptions(),
    withSelectedOptions(),
    withSelectedCustomOptions(),
    withSelectedBundleOptions({
      priceIncludesMinimalFromUnselectedOptions: false,
    }),
    withSelectedGroupedItems()
  );
export default EnhanceAddToCartModal;
